<mad-data-table
  [filterMode]="'NONE'"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [paginationEnabled]="paginationEnabled"
  [pageSizeOptions]="[5, 10, 15]"
  [defaultPageSize]="10"
>
  <ng-container madColumnDef="gender">
    <div *madCellDef="let element">
      @if (element.gender === 'female') {
        <mat-icon class="material-symbols-outlined">woman</mat-icon>
      }
      @if (element.gender === 'male') {
        <mat-icon class="material-symbols-outlined">man</mat-icon>
      }
    </div>
  </ng-container>
  <ng-container madColumnDef="title">
    <div *madCellDef="let element" class="{{ element.title === 'Miss' ? 'mrs-style' : 'mr-style' }}">
      {{ element.title }}
    </div>
  </ng-container>
</mad-data-table>
